import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    // gcTime 24h keeps unused query data resident long enough for the offline
    // cache persistence (see queryPersist.ts) to capture and restore it.
    // refetchOnWindowFocus catches board changes missed while a tab was backgrounded
    // (belt-and-suspenders alongside the splits socket nudge + reconnect-refetch).
    queries: {
      staleTime: 30_000,
      gcTime: 1000 * 60 * 60 * 24,
      retry: false,
      refetchOnWindowFocus: true,
    },
  },
});
